import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";

export default class DashboardScreenMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {RevisableLanguagePack} languagePack 
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack, mediatorManager) {
        super(target, dispatcher, layoutManager, clickEaterFactory);
        this._mediatorManager = mediatorManager;
        this._languagePack = languagePack;
    }

    initialize() {
        super.initialize();
        this.preventClickThrough();


        this._dashboardEpiMediator = this._mediatorManager.createMediator(this._target.DashboardTab1, SkinKeyRegistry.DASHBOARD_EPI_TAB_SKIN);
        this._dashboardHealthSystemsMediator = this._mediatorManager.createMediator(this._target.DashboardTab2, SkinKeyRegistry.DASHBOARD_HEALTH_SYSTEMS_TAB_SKIN);
        this._dashboardRCCEMediator = this._mediatorManager.createMediator(this._target.DashboardTab3, SkinKeyRegistry.DASHBOARD_RCCE_TAB_SKIN);

        this._handleCloseButtonBound = this._handleCloseButton.bind(this);
        this._closeButton = this.createButton(this._target.closeButton, this._handleCloseButtonBound);

        this._handleTabEpiButtonBound = this._handleTabEpiButton.bind(this);
        this._tabEpiButton = this.createButton(this._target.TabButton1, this._handleTabEpiButtonBound, this._languagePack.getText(`dashboard.mainScreen.buttonEpiTab`));

        this._handleTabHealthSystemsButtonBound = this._handleTabHealthSystemsButton.bind(this);
        this._tabHealthSystemsButton = this.createButton(this._target.TabButton2, this._handleTabHealthSystemsButtonBound, this._languagePack.getText(`dashboard.mainScreen.buttonHealthSystemsTab`));

        this._handleTabRCCEBound = this._handleTabRCCE.bind(this);
        this._tabRCCEButton = this.createButton(this._target.TabButton3, this._handleTabRCCEBound, this._languagePack.getText(`dashboard.mainScreen.buttonRCCETab`));

        this._target.TitleExtraBoldTextField.text = this._languagePack.getText(`dashboard.mainScreen.mainTitle`);
        this._target.TitleLightTextField.text = this._languagePack.getText(`dashboard.mainScreen.secondaryTitle`);
        this._target.TitleSubTextField.text = this._languagePack.getText(`dashboard.mainScreen.subTitle`);

        this._handleTabEpiButton();
    }
    destroy() {
        super.destroy();
        this._dashboardEpiMediator.destroy();
        this._dashboardHealthSystemsMediator.destroy();
        this._dashboardRCCEMediator.destroy();
        this._closeButton = null;
    }

    _handleCloseButton() {
        this.closeScreen(this._target);
    }


    _handleTabEpiButton() {
        this._dashboardEpiMediator.show();
        this._dashboardHealthSystemsMediator.hide();
        this._dashboardRCCEMediator.hide();

        this._tabEpiButton.setSelected(true);
        this._tabEpiButton.setFocus(true);

        this._tabHealthSystemsButton.setSelected(false);
        this._tabHealthSystemsButton.setFocus(false);

        this._tabRCCEButton.setSelected(false);
        this._tabRCCEButton.setFocus(false);
    }

    _handleTabHealthSystemsButton() {
        this._dashboardEpiMediator.hide();
        this._dashboardHealthSystemsMediator.show();
        this._dashboardRCCEMediator.hide();

        this._tabEpiButton.setSelected(false);
        this._tabEpiButton.setFocus(false);

        this._tabHealthSystemsButton.setSelected(true);
        this._tabHealthSystemsButton.setFocus(true);

        this._tabRCCEButton.setSelected(false);
        this._tabRCCEButton.setFocus(false);
    }

    _handleTabRCCE() {
        this._dashboardEpiMediator.hide();
        this._dashboardHealthSystemsMediator.hide();
        this._dashboardRCCEMediator.show();

        this._tabEpiButton.setSelected(false);
        this._tabEpiButton.setFocus(false);

        this._tabHealthSystemsButton.setSelected(false);
        this._tabHealthSystemsButton.setFocus(false);

        this._tabRCCEButton.setSelected(true);
        this._tabRCCEButton.setFocus(true);
    }
}